import React, { useCallback, useEffect, useState } from 'react';
import { LinearProgress, Link } from '@material-ui/core';
import { useTypedTranslation, useLinearProgressCalc } from '@app/hooks';
import { WarningBlock } from '@app/components';
import { getErrorMessageManageMfa, parseString } from '@app/helpers';
import { goBackToList } from '@app/modules/mfaToken/helpers';
import { AxiosError } from 'axios';
import { useSelector } from 'react-redux';
import { SetLoginForm } from '@app/models';
import Icon from '@app/components/Icon/index';

interface IProps {
    registrationCallback: Function;
    bottomButton?: JSX.Element;
    setLoginForm?: SetLoginForm;
}

type ErrorCallback = {
    metaData: {
        code: number;
        type: string;
    };
};

const timeoutWaitU2fRegister = 60;

export const SetUpDeviceU2f: React.SFC<IProps> = ({ registrationCallback, bottomButton, setLoginForm }) => {
    const [error, setError] = useState({ msg: '', type: '' });
    const [isNeedStartTimer, setIsNeedStartTimer] = useState<boolean>(false);
    const [isNeedStartRegistration, setIsNeedStartRegistration] = useState<boolean | null>(null);
    const axioserror: AxiosError<any> = useSelector((state: any) => state.signIn.error);
    const errorUri = axioserror?.response?.data?.error_uri ?? '';
    const { providers } = parseString(window.atob(errorUri));
    const isMultipleProviders = providers?.length > 1;
    const { translation } = useTypedTranslation();
    const completed = useLinearProgressCalc(timeoutWaitU2fRegister, isNeedStartTimer);
    const handleTryAgainClick = useCallback(() => {
        setIsNeedStartRegistration(true);
        setError({
            msg: '',
            type: ''
        });
    }, []);

    useEffect(() => {
        const errorCallback = (err: ErrorCallback) => {
            const { code, type } = err?.metaData ?? {};
            const errorMsg = getErrorMessageManageMfa(translation, code);
            setIsNeedStartRegistration(false);
            setIsNeedStartTimer(false);
            setError({
                msg: errorMsg,
                type
            });
        };
        if (isNeedStartRegistration || isNeedStartRegistration === null) {
            registrationCallback(setIsNeedStartTimer, errorCallback);
        }
    }, [isNeedStartRegistration]);

    return (
        <>
            <div className='manage-mfa-token__u2f--wrapper'>
                <h1>{translation('MFA_U2F_PROVIDER')}</h1>
                <p className={'manage-mfa-token__text'}>
                    {translation('MFA_U2F_POINT_ONE_PART_ONE')}
                    <b>{translation('MFA_U2F_POINT_ONE_PART_TWO')}</b>
                    {translation('MFA_U2F_POINT_ONE_PART_THREE')}
                </p>
                <p className={'manage-mfa-token__text'}>{translation('MFA_U2F_POINT_TWO')}</p>
                <p className={'manage-mfa-token__text'}>
                    {translation('MFA_U2F_POINT_THREE')}
                    {isMultipleProviders && <Link onClick={goBackToList(setLoginForm)}>{translation('MFA_VERIFY_ANOTHER_WAY')}</Link>}
                </p>
                <WarningBlock className='manage-mfa-token__warning' isWarning={!!error.msg} warningMessage={error.msg} errorType={error.type} onClick={handleTryAgainClick} />
                <Icon icon='twoFaTokenIco' className='manage-mfa-token__u2f-icon' />
                <LinearProgress className='manage-mfa-token__linear-progress' variant='determinate' value={completed} />
            </div>
            {bottomButton}
        </>
    );
};
